<style>
#IdentificationWrapper .v-list__tile {
  height: auto !important;
}
#IdentificationWrapper .btn--card {
  position: absolute;
  right: 10px;
  bottom: 10px;
}
#IdentificationWrapper .v-list {
  position: relative;
}
#IdentificationWrapper .caption--identification {
  display: inline;
  text-align: center;
  vertical-align: super;
}
</style>

<template>
  <Modal
    modalName="Identification"
    title="Identyfikacja"
    @saved='save'
    @closed='close'
    :buttons="['save']"
  >
    <div id="IdentificationWrapper">
      <v-layout
        row
        wrap
        v-if="isTransmissionEasementAdding"
      >
        <v-flex xs12>
          <p>Poniżej znajduje się lista numerów zidentyfikowanych działek. Wybierz jedną z nich i zatwierdź swój wybór przyciskiem u dołu okna.</p>
          <v-list style="width: 100%">
            <template v-for="(feature, index) in graniceDzialekFeatures">
              <v-list-tile
                class="list--el"
                style="border-bottom: 1px solid lightgrey"
                :key="`${feature.getId()}`"
              >
                <v-list-tile-content>
                  <v-list-tile-title><span v-text="getId('granice_dzialek', feature)"></span></v-list-tile-title>
                </v-list-tile-content>
                <v-list-tile-action>
                  <v-radio-group
                    v-model="radioGroup"
                    style="justify-content: flex-end;"
                  >
                    <v-radio
                      :key="`${feature.getId()}`"
                      :value="feature"
                      color="#4f7052"
                    ></v-radio>
                  </v-radio-group>
                </v-list-tile-action>
              </v-list-tile>
            </template>
          </v-list>
        </v-flex>
      </v-layout>

      <v-expansion-panel
        v-else
        focusable
        v-model="panelIndex"
      >
        <template v-for="(layer, key) in layers">
          <v-expansion-panel-content
            v-for="(feature, index) in (layer.cluster ? layer.features_cluster : layer.features)"
            :key="`${key}-${index}`"
          >
            <div slot="header">Warstwa: <span v-text="layer.name"></span></div>
            <v-list>
              <v-list-tile :key="feature.getId()">
                <v-list-tile-content>
                  <v-list-tile-title>ID</v-list-tile-title>
                  <v-list-tile-sub-title v-text="getId(layer.layer, feature)"></v-list-tile-sub-title>
                </v-list-tile-content>
              </v-list-tile>
              <v-list-tile
                v-for="item in getProperties(layer.layer, feature)"
                :key="item.title"
                v-if="item.value"
              >
                <v-list-tile-content>
                  <v-list-tile-title v-text="item.title"></v-list-tile-title>
                  <v-list-tile-sub-title v-text="item.value"></v-list-tile-sub-title>
                </v-list-tile-content>
              </v-list-tile>
              <span
                class="btn--card"
                title="Otwórz kartę obiektu"
                @click="openFeatureCard(layer.layer.values_.full_type, feature)"
              >
                <v-icon
                  class="table__btn--blue table__btn--padding"
                  style="padding-left: 25px;"
                >
                  note
                </v-icon>
                <p class="caption caption--identification">KARTA OBIEKTU</p>
              </span>
            </v-list>

          </v-expansion-panel-content>
        </template>
      </v-expansion-panel>

    </div>
  </Modal>
</template>

<script>
import Modal from '../../../shared/Modal';

import chain from "lodash/chain";
import value from "lodash/value";
import mixin from "lodash/mixin";
import _ from "lodash/wrapperLodash";
import map from "lodash/map";
//import filter from "lodash/filter";
//import includes from "lodash/includes";
import isEmpty from "lodash/isEmpty";
//import some from "lodash/some";
//import isArray from "lodash/isArray";
import each from "lodash/each";
import uniqBy from "lodash/uniqBy";
import isString from "lodash/isString";
mixin(_, {
  map,
  //filter,
  //includes,
  isEmpty,
  //some,
  //isArray,
  each,
  chain,
  uniqBy,
  isString
});
_.value = value;
_.prototype.value = value;

export default {
  components: {
    Modal
  },
  data: () => ({
    panelIndex: null,
    radioGroup: undefined
  }),
  watch: {
    panelIndex() {
      this.selectedLayer.getSource().clear(true);
      if(this.panelIndex !== null) {
        const feature = this.flatFeature[this.panelIndex];

        this.selectedLayer.getSource().addFeature(feature);
      }
    },
    radioGroup(feature) {
      this.selectedLayer.getSource().clear(true);
      if(feature) {
        this.selectedLayer.getSource().addFeature(feature.__value);
      }
    }
  },
  computed: {
    activeModals() {
      return this.$store.getters.getModalsList;
    },
    map() {
      return this.$store.getters.getMap;
    },
    selectedLayer() {
      return this.map
        .getLayers()
        .item(3)
        .getLayers()
        .item(0);
    },

    flatFeature() {
      const features = [];
      _.each(this.layers, (layer, key) => {
        let features2 = [];
        _.each(layer.features, (feature, index) => {
          if(layer.cluster) {
            features2.push(...feature.get('features'));
          } else {
            features2.push(feature);
          }
        });
        features.push(..._.uniqBy(features2, (feature) => feature.getId()));
      });
      return features;
    },
    modelWatTimeStep() {
      return this.$store.getters.getModelWatTimeStep;
    },
    isTransmissionEasementAdding() {
      return this.$store.getters.getTransmissionEasementAdding;
    },
    geoportalName() {
      return this.$store.getters.getAquagisName;
    },
  },
  created() {
    this.layers = {};
    this.graniceDzialekFeatures = [];
    const keyGD = `app_layer_${this.geoportalName}:granice_dzialek`;
    this.$root.$on("identificationFeaturesToSelect", (layers) => {
      this.layers = layers;

      if(keyGD in layers) {
        this.graniceDzialekFeatures = _(layers[keyGD].features)
          .uniqBy((feature) => feature.getId())
          .map((feature) => this.$root.createProxy(feature))
          .value();
      } else {
        this.graniceDzialekFeatures = [];
      }
      this._computedWatchers.flatFeature.update();
      this.$forceUpdate();
    });
  },
  mounted() {
    this.$root.$on('featureEdited', this.setFeatureData);
  },
  methods: {
    show(title) {
      if(this.activeModals.indexOf(title) == -1) {
        this.$store.commit("addModal", title);
        this.$modal.show(title);
      }
    },
    capitalizeFirstLetter(string) {
      return string.charAt(0).toUpperCase() + string.slice(1);
    },
    close() {
      if(this.isTransmissionEasementAdding) {
        this.radioGroup = undefined;
        this.$root.$emit("identificationFeature", 'cancel');
      }
      this.$store.commit("setServitudeAdding", false);
    },
    save() {
      if(this.isTransmissionEasementAdding) {
        if(!this.radioGroup) {
          this.$root.$emit(
            "showSnackbar",
            "red",
            "Nie wybrano działki"
          );
          return;
        } else {
          this.show('addServitudeModal');
          this.$modal.hide("Identification");
          this.$root.$emit('setPlotFeature', this.radioGroup);
        }
      } else {
        this.$modal.hide("Identification");
      }
    },
    formatDate(date) {
      if(!date) {
        return null;
      } else {
        const [year, month, day] = date.split("-");
        return `${day}.${month}.${year}`;
      }
    },
    toFixed(value, _number = 2) {
      return typeof value.toFixed === 'function' ? value.toFixed(_number) : value;
    },
    getProperties(layer, feature) {
      const name = layer.get('name');

      if(name && name.endsWith('granice_dzialek')) {
        return [{
          title: 'Nazwa obrębu',
          value: feature.get('nazwa_obre')
        }, {
          title: 'Numer obrębu',
          value: feature.get('nr_obreb')
        }, {
          title: 'Teryt',
          value: feature.get('teryt')
        }];
      } else if(name && name.startsWith('Model Wodociągowy')) {
        const timeStep = this.modelWatTimeStep - 1;
        if(name.endsWith('odcinki')) {
          return [{
            title: 'Typ obiektu',
            value: feature.get('objecttype')
          }, {
            title: 'Natężenie przepływu',
            value: this.toFixed(feature.get('flow')[timeStep])
          }, {
            title: 'Współczynnik tarcia',
            value: this.toFixed(feature.get('friction')[timeStep])
          }, {
            title: 'Jednostkowy wskaźnik strat ciśnienia',
            value: this.toFixed(feature.get('headloss')[timeStep])
          }, {
            title: 'Wiek wody',
            value: this.toFixed(feature.get('quality')[timeStep])
          }, {
            title: 'Natężenie reakcji',
            value: this.toFixed(feature.get('reactionrate')[timeStep])
          }, {
            title: 'Status przewodu',
            value: feature.get('velocity')[timeStep]
          }];
        } else {
          return [{
            title: 'Typ obiektu',
            value: feature.get('objecttype')
          }, {
            title: 'Obliczone zużycie w danym momencie symulacji',
            value: this.toFixed(feature.get('demand')[timeStep])
          }, {
            title: 'Wysokość linii ciśnienia',
            value: this.toFixed(feature.get('head')[timeStep])
          }, {
            title: 'Wartość ciśnienia',
            value: this.toFixed(feature.get('pressure')[timeStep])
          }, {
            title: 'Wiek wody',
            value: this.toFixed(feature.get('quality')[timeStep])
          }];
        }
      }

      return _.map(layer.get('fields'), (field) => {
        if('dictionary' in field) {
          const dictionary = field.dictionary[feature.get(field.name)] || {};
          return {
            title: field.display_name || this.capitalizeFirstLetter(field.name),
            value: dictionary.value || ''
          };
        } else if(field.data_type === "datetime") {
          return {
            title: field.display_name || this.capitalizeFirstLetter(field.name),
            value: feature.get(field.name) ? this.formatDate(feature.get(field.name).split("T")[0]) : ''
          };
        } else {
          return {
            title: field.display_name || this.capitalizeFirstLetter(field.name),
            value: feature.get(field.name) || ''
          };
        }
      });
    },
    getId(layer, feature) {
      let name = layer;
      if(!_.isString(layer)) {
        name = layer.get('name');
      }
      if(name && name.endsWith('granice_dzialek')) {
        return feature.get('nr_dzialka');
      } else if(name && name.startsWith('Model Wodociągowy')) {
        if(name.endsWith('odcinki')) {
          return feature.get('link_id');
        } else {
          return feature.get('node_id');
        }
      } else if (name && (name == 'tasks' || name == 'investments' || name == 'transmission_easement')) {
        return feature.get('id');
      }
      return feature.getId();
    },
    openFeatureCard(layer, data) {
      if (layer == 'transmission_easement') {
        let payload = {
          object_id: data.values_.id,
          object_table: null,
          object_type: "transmission_easement",
          limit: 5,
          events_count: true
        };

        this.$store.dispatch("getServitude", {
          object_id: data.values_.id,
          with_geometry: 'true'
        }).then(r => {
          if(r) {
            this.$store
              .dispatch("getFeatureEvents", payload)
              .then(success => {
                if(success) {
                  this.show('servitudeCardModal');
                } else {
                  this.$root.$emit(
                    "showSnackbar",
                    "red",
                    "Podczas pobierania służebności przesyłu wystąpił błąd"
                  );
                }
              });

          }
        });
      } else if (layer == 'tasks') {
        let payload = {
          object_id: data.id_,
          object_type: "tasks",
          limit: 5,
          events_count: true
        };
        this.$store.dispatch("getFeatureEvents", payload).then(success => {
          if(success) {
            this.show("taskCardModal");
            this.$root.$emit('loadTaskData', data.values_.properties, true);
          } else {
            this.$root.$emit(
              "showSnackbar",
              "red",
              "Podczas pobierania danych zadania wystąpił błąd"
            );
          }
        });
      } else if (layer == 'investments') {
        this.show('investmentCardModal');
        this.$root.$emit('loadTab', 0);
        this.$root.$emit('loadInvestment', data.values_.properties);
      }
      else {
        this.selectedFeature = data;
        this.$root.$emit("featureData", layer, data, this.selectedFeature.getId());
      }  
    },
    setFeatureData(data) {
      for(let property in data) {
        data[property] = Number(data[property]) || data[property];
      }
      this.selectedFeature.setProperties(data, true);
      this.$forceUpdate();
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/viewer/map/modals/Identification.vue